import { render, staticRenderFns } from "./BestSellingBlock.vue?vue&type=template&id=b7a3b0ce&"
import script from "./BestSellingBlock.vue?vue&type=script&lang=js&"
export * from "./BestSellingBlock.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {UiSwiperCarousel: require('/app/components/UI/UiSwiperCarousel.vue').default})
